export const getUserBranchesFilter = (userSucAlias) => {
  const allAccess= Boolean(Number(localStorage.getItem("controlador"))) || localStorage.getItem("role") === "admin" || localStorage.getItem("role") === "superusuario";
  if (allAccess) {
    return localStorage.getItem("suc_auth");
  } else {
    const sucursalUsuario = localStorage.getItem("sucursal");
    if(userSucAlias){
      return `${sucursalUsuario}, ${userSucAlias}`
    }
    return sucursalUsuario;
  }
}

export const hasFullAccess = () => {
  return Boolean(Number(localStorage.getItem("controlador"))) || localStorage.getItem("role") === "admin" || localStorage.getItem("role") === "superusuario";
}
